import React from 'react';
import { Form, Grid, Input, Label } from 'semantic-ui-react';
import TRANSLATIONS from '@translations/translationNamespaces';
import { withTranslation } from 'react-i18next';

const IFrameElement = ({ t, isViewMode, element, elementErrors, onChange, sectionNumber }) => {
  const handleChange = (e, { value, name }) =>
    onChange(prevState => ({
      offerSections: prevState.offerSections.reduce((acc, section) => {
        if (section.position === sectionNumber) {
          return acc.concat([
            {
              ...section,
              elements: section.elements.reduce((elementsAcc, el) => {
                if (element.position === el.position) {
                  return elementsAcc.concat([
                    {
                      ...el,
                      [name]: value,
                    },
                  ]);
                }
                return elementsAcc.concat([el]);
              }, []),
            },
          ]);
        }
        return acc.concat([section]);
      }, []),
    }));

  return (
    <Form.Group>
      <Grid container stackable columns={1} divided>
        <Grid.Column>
          <Form.Field>
            {elementErrors?.url && (
              <Label color="red" className="mb-1">
                {t(elementErrors?.url)}
              </Label>
            )}
            <Form.Field className="d-flex justify-content-between">
              <label>{t('iframe.url')}</label>
            </Form.Field>
            <Input
              name="url"
              value={element.url}
              type="text"
              onChange={(e, v) => handleChange(e, v)}
              label={{ icon: 'asterisk' }}
              labelPosition="right corner"
              required
              disabled={isViewMode}
            />
          </Form.Field>
        </Grid.Column>
      </Grid>
    </Form.Group>
  );
};

export default withTranslation(TRANSLATIONS.OFFERS)(IFrameElement);
